import React from 'react'

interface UrlTaggedTextProps {
  content: string
  className: string
}

export function UrlTaggedText({ content, className }: UrlTaggedTextProps): JSX.Element {
  const parts = []
  let lastIndex = 0
  let match

  // Iterate through all matches of the url pattern
  while ((match = taggedUrlPattern.exec(content)) !== null) {
    const [fullMatch, url, text] = match

    // Push the text before the match (if any)
    if (match.index > lastIndex) {
      parts.push(content.substring(lastIndex, match.index))
    }

    // Push the link as a TouchableOpacity
    parts.push(<a href={url} key={match.index} className='underline text-sky-500'>{text}</a>)

    // Update the last index to the end of the current match
    lastIndex = match.index + fullMatch.length
  }

  // Push the remaining text after the last match
  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex))
  }

  return <span className={className}>{parts}</span>
};

const taggedUrlPattern = /\[url="(.+?)"\](.+?)\[\/url\]/g

export default UrlTaggedText
